import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';

const messages = {
  en, // English
  ar, // Arabic
  es, // Spanish
};

const i18n = createI18n({
  legacy: false,  // ✅ Use the Composition API mode
  locale: 'en', // Default language
  fallbackLocale: 'en', // Fallback if a translation is missing
  globalInjection: true,
  messages,
});

export default i18n;
